export default "__VITE_ASSET__79733ad0__"